import { Modal } from 'bootstrap';

import { routes } from '@/shared/routes';
import { MFA_CODE_REGEX } from '@/shared/utils/validation';

import { execute, modelId } from '@/front/actions/utils';
import { POST } from '@/front/fetch';
import { alertModal, confirmModal } from '@/front/modal';

export const resendInvite = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const memberId = button.dataset.value;

  if (memberId) {
    await execute(POST, routes.members.resendInvite({ id: memberId }));
  }
};

export const resetPassword = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const memberId = button.dataset.value;

  if (memberId) {
    await execute(POST, routes.members.resetPassword({ id: memberId }));
  }
};

export const enableMfa = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const memberId = button.dataset.value;

  if (memberId) {
    const modalDiv = document.getElementById('mfa-modal') as HTMLDivElement;
    const qrImg = document.getElementById('mfa-qr') as HTMLImageElement;
    const codeInput = document.getElementById('mfa-code') as HTMLInputElement;
    const confirmButton = document.getElementById('mfa-confirm') as HTMLButtonElement;

    const res = await POST(routes.members.enableMfa({ id: memberId }));

    const { qrUrl } = await res.json();

    qrImg.src = qrUrl;

    const modal = new Modal(modalDiv);

    confirmButton.addEventListener('click', async () => {
      const code = codeInput.value;

      if (!MFA_CODE_REGEX.test(code)) {
        alertModal('Invalid code');
        return;
      }

      const res = await POST(routes.members.confirmMfa({ id: memberId }), { code });

      const { success } = await res.json();

      if (success) {
        modal.hide();
        window.location.reload();
      } else {
        codeInput.value = '';
        alertModal('Invalid code, please try again');
      }
    });

    modal.show();
  }
};

export const disableMfa = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const memberId = button.dataset.value;

  if (memberId) {
    if (await confirmModal('Are you sure you want to disable two-factor authentication?', 'Disable', 'warning')) {
      await POST(routes.members.disableMfa({ id: memberId }));

      window.location.reload();
    }
  }
};

export const setTaskSummaryEmail = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const memberId = modelId();
  const taskSummaryEmailMode = Number(button.dataset.value);

  if (memberId && !Number.isNaN(taskSummaryEmailMode)) {
    await execute(POST, routes.members.setTaskSummaryEmail({ id: memberId }), { taskSummaryEmailMode });
    window.location.reload();
  }
};
